import apiClient from '@shared/api'
import { installRequestInterceptor } from '@shared/utils/interceptors/requestInterceptor'
import { ERouterList } from '@urgent/router/constants/router-list'
import type { IRouteContext } from '@shared/types/route-context'
import type { ISessionData } from '@urgent/router/types/session-data'

export const auth = ({ to, next }: IRouteContext): void => {
  const visitId: string = to.params.visitId ? (to.params.visitId as string) : ''
  const unparsedSessionData: string | null = localStorage.getItem(visitId)
  let sessionToken = ''
  if (visitId && unparsedSessionData) {
    const sessionData: ISessionData = JSON.parse(unparsedSessionData)
    sessionToken = sessionData.sessiontoken
  }
  installRequestInterceptor({ apiClient, sessionToken })
  return sessionToken
    ? next()
    : next({
        name: ERouterList.HOME,
      })
}
